export default {
  dev: 'development',
  int: 'integration',
  prod: 'production',
  qa: 'qualityassurance'
}
